const TUI_KAZAKH_LANGUAGE_ADDON_COMMERCE = {
  cardNumber: ['Сан', 'Карточка нөмірі'],
  cardExpiry: ['Мерзімі бітеді', 'Арқылы жарамды']
};
const TUI_KAZAKH_LANGUAGE_ADDON_EDITOR = {
  colorSelectorModeNames: ['Бірыңғай түс', 'Градиент'],
  toolbarTools: {
    undo: 'Болдырмау',
    redo: 'Қайталау',
    font: 'Қаріп',
    fontStyle: 'Қаріп стилі',
    fontSize: 'Қаріп өлшемі',
    bold: 'Қалың',
    italic: 'Курсив',
    underline: 'Астын сызу',
    strikeThrough: 'Соғу',
    justify: 'Ақтау',
    justifyLeft: 'Сол жаққа ақтаңыз',
    justifyCenter: 'Орталықты негіздеу',
    justifyRight: 'Дұрыс негіздеу',
    justifyFull: 'Толық негіздеу',
    list: 'Тізім',
    indent: 'Шегініс',
    outdent: 'Ашық',
    unorderedList: 'Реттелмеген тізім',
    orderedList: 'Реттелген тізім',
    quote: 'Дәйексөз',
    foreColor: 'Түс',
    backColor: 'Фон түсі',
    hiliteColor: 'Түсті бөлектеу',
    clear: 'Таза',
    link: 'Сілтеме',
    attach: 'Файлды тіркеңіз',
    tex: 'TeX енгізіңіз',
    code: 'Код',
    image: 'Суретті енгізу',
    insertHorizontalRule: 'Көлденең ережені енгізіңіз',
    superscript: 'Жоғарғы сызба',
    subscript: 'Жазу',
    insertTable: 'Кестені енгізу',
    insertGroup: 'Топты енгізу',
    hiliteGroup: 'Хилит тобы',
    removeGroup: 'Топты жою',
    insertAnchor: 'Анкерді салыңыз',
    mergeCells: 'Ұяшықтарды біріктіру',
    splitCells: 'Бөлінген жасушалар',
    rowsColumnsManaging: 'Жолдар мен бағандарды басқару',
    cellColor: 'Жасуша түсі',
    setDetails: 'Егжей',
    removeDetails: 'Мәліметтерді жою'
  },
  editorEditLink: {
    urlExample: 'example.com',
    anchorExample: 'Якорь'
  },
  editorTableCommands: [['Алдында бағанды енгізу', 'Бағананы кейін енгізіңіз'], ['Алдында жолды енгізіңіз', 'Жолды кейін енгізіңіз'], ['Бағанды жою', 'Жолды жою']],
  editorCodeOptions: ['Мәтіндегі код', 'Блоктағы код'],
  editorFontOptions: {
    small: 'Кішкентай',
    large: 'Үлкен',
    normal: 'Қалыпты',
    title: 'Тақырып',
    subtitle: 'Субтитр'
  }
};
const TUI_KAZAKH_LANGUAGE_ADDON_TABLE = {
  showHideText: 'Көрсету/Жасыру',
  paginationTexts: {
    pages: 'Беттер',
    linesPerPage: 'Әр беттегі жолдар',
    of: 'ның'
  }
};
const TUI_KAZAKH_LANGUAGE_COUNTRIES = {
  AD: 'Andorra',
  AE: 'United Arab Emirates',
  AF: 'Afghanistan',
  AG: 'Antigua and Barbuda',
  BL: 'Saint Barthélemy',
  AI: 'Anguilla',
  AL: 'Albania',
  AM: 'Armenia',
  AO: 'Angola',
  AR: 'Argentina',
  AT: 'Austria',
  AU: 'Australia',
  AW: 'Aruba',
  AZ: 'Azerbaijan',
  BA: 'Bosnia and Herzegovina',
  BB: 'Barbados',
  BD: 'Bangladesh',
  BE: 'Belgium',
  BF: 'Burkina Faso',
  BG: 'Bulgaria',
  BH: 'Bahrain',
  BI: 'Burundi',
  BJ: 'Benin',
  GF: 'Guyana',
  BM: 'Bermuda',
  BN: 'Brunei Darussalam',
  BO: 'Bolivia',
  BQ: 'Bonaire, Sint Eustatius and Saba',
  BR: 'Brazil',
  BS: 'Bahamas',
  BT: 'Bhutan',
  BW: 'Botswana',
  BY: 'Belarus',
  BZ: 'Belize',
  CA: 'Canada',
  CD: 'Dem. Rep. Congo (Kinshasa)',
  CF: 'Central African Republic',
  CG: 'Congo (Brazzaville)',
  CH: 'Switzerland',
  CI: 'Ivory Coast',
  CL: 'Chile',
  CM: 'Cameroon',
  CN: 'China',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  CV: 'Cape Verde',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DE: 'Germany',
  DJ: 'Djibouti',
  DK: 'Denmark',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  DZ: 'Algeria',
  EC: 'Ecuador',
  EE: 'Estonia',
  EG: 'Egypt',
  ER: 'Eritrea',
  ES: 'Spain',
  ET: 'Ethiopia',
  FI: 'Finland',
  FJ: 'Fiji',
  FK: 'Falkland Islands',
  FM: 'F.S. of Micronesia',
  FR: 'France',
  GA: 'Gabon',
  GB: 'United Kingdom',
  GD: 'Grenada',
  GE: 'Georgia',
  GP: 'Guadeloupe',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GL: 'Greenland',
  GM: 'Gambia',
  GN: 'Guinea',
  MF: 'Saint-Martin',
  GQ: 'Equatorial Guinea',
  GR: 'Greece',
  GT: 'Guatemala',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HK: 'Hong Kong',
  HN: 'Honduras',
  HR: 'Croatia',
  HT: 'Haiti',
  HU: 'Hungary',
  ID: 'Indonesia',
  IE: 'Ireland',
  IL: 'Israel',
  IN: 'India',
  IQ: 'Iraq',
  IR: 'Iran',
  IS: 'Iceland',
  IT: 'Italy',
  JM: 'Jamaica',
  JO: 'Jordan',
  JP: 'Japan',
  KE: 'Kenya',
  KG: 'Kyrgyzstan',
  KH: 'Cambodia',
  KM: 'Comoros',
  KN: 'Saint Kitts and Nevis',
  KP: 'Korean PDR',
  KR: 'Rep. Korea',
  KW: 'Kuwait',
  KY: 'Cayman Islands',
  KZ: 'Kazakhstan',
  LA: 'Laos',
  LB: 'Lebanon',
  LC: 'Saint Lucia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  LV: 'Latvia',
  LY: 'Libya',
  MA: 'Morocco',
  MC: 'Monaco',
  MD: 'Moldova',
  ME: 'Montenegro',
  MQ: 'Martinique',
  MG: 'Madagascar',
  MK: 'Rep. of North Macedonia',
  ML: 'Mali',
  MM: 'Burma (Myanmar)',
  MN: 'Mongolia',
  MO: 'Macau',
  RE: 'Réunion',
  MR: 'Mauritania',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Mauritius',
  MV: 'Maldives',
  MW: 'Malawi',
  MX: 'Mexico',
  MY: 'Malaysia',
  MZ: 'Mozambique',
  NA: 'Namibia',
  NC: 'New Caledonia',
  NE: 'Niger',
  NG: 'Nigeria',
  NI: 'Nicaragua',
  NL: 'Netherlands',
  NO: 'Norway',
  NP: 'Nepal',
  NZ: 'New Zealand',
  OM: 'Oman',
  PA: 'Panama',
  PE: 'Peru',
  PF: 'French Polynesia (Tahiti)',
  PG: 'Papua New Guinea',
  PH: 'Philippines',
  PK: 'Pakistan',
  PL: 'Poland',
  PT: 'Portugal',
  PW: 'Palau',
  PY: 'Paraguay',
  QA: 'Qatar',
  YT: 'Mayotte',
  RO: 'Romania',
  RS: 'Serbia',
  RU: 'Russia',
  RW: 'Rwanda',
  SA: 'Saudi Arabia',
  SB: 'Solomon Islands',
  SC: 'Seychelles',
  SD: 'Sudan',
  SE: 'Sweden',
  SG: 'Singapore',
  SH: 'Saint Helena',
  SI: 'Slovenia',
  SK: 'Slovakia',
  SL: 'Sierra Leone',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somalia',
  SR: 'Suriname',
  ST: 'Sao Tome and Principe',
  SV: 'El Salvador',
  SX: 'Sint Maarten',
  SY: 'Syrian Arab Republic',
  SZ: 'Swaziland',
  TC: 'Turks and Caicos',
  TD: 'Chad',
  TG: 'Togo',
  TH: 'Thailand',
  TJ: 'Tajikistan',
  TL: 'East Timor',
  TM: 'Turkmenistan',
  TN: 'Tunisia',
  TO: 'Tonga',
  TR: 'Turkey',
  TT: 'Trinidad and Tobago',
  TW: 'Taiwan',
  TZ: 'Tanzania',
  UA: 'Ukraine',
  UG: 'Uganda',
  US: 'USA',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VC: 'Saint Vincent and the Grenadines',
  VE: 'Venezuela',
  VG: 'British Virgin Islands',
  VN: 'Vietnam',
  VU: 'Vanuatu',
  WS: 'Samoa',
  XK: 'Kosovo',
  YE: 'Yemen',
  ZA: 'South Africa',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  AC: 'Ascension Island',
  AS: 'American Samoa',
  AX: 'Åland Islands',
  CC: 'Cocos (Keeling) Islands',
  CK: 'Cook Islands',
  CX: 'Christmas Island',
  EH: 'Western Sahara',
  FO: 'Faroe Islands',
  GG: 'Guernsey',
  GU: 'Guam',
  IM: 'Isle of Man',
  JE: 'Jersey',
  IO: 'British Indian Ocean Territory',
  KI: 'Kiribati',
  MH: 'Marshall Islands',
  MP: 'Northern Mariana Islands',
  NF: 'Norfolk Island',
  NR: 'Nauru',
  NU: 'Niue',
  PM: 'Saint Pierre and Miquelon',
  PR: 'Puerto Rico',
  PS: 'Palestine',
  SJ: 'Svalbard and Jan Mayen',
  SS: 'South Sudan',
  TA: 'Tristan da Cunha',
  TK: 'Tokelau',
  TV: 'Tuvalu',
  VA: 'Holy See',
  VI: 'Virgin Islands',
  WF: 'Wallis and Futuna'
};
const TUI_KAZAKH_LANGUAGE_CORE = {
  months: ['Қаңтар', 'Ақпан', 'Наурыз', 'Сәуір', 'Мамыр', 'Маусым', 'Шілде', 'Тамыз', 'Қыркүйек', 'Қазан', 'Қараша', 'Желтоқсан'],
  close: 'Жабық',
  clear: 'Өрісті тазалау',
  nothingFoundMessage: 'Ештеңе табылмады',
  defaultErrorMessage: 'Мән жарамсыз',
  spinTexts: ['Алдыңғы', 'Келесі'],
  shortWeekDays: ['Дүй', 'Ссе', 'Сәр', 'Бсе', 'Жұм', 'Сб', 'Жек'],
  countries: TUI_KAZAKH_LANGUAGE_COUNTRIES
};
const TUI_KAZAKH_LANGUAGE_KIT = {
  cancel: 'Болдырмау',
  done: 'Дайын',
  more: 'Көбірек',
  otherDate: 'Басқа күн...',
  showAll: 'Барлығын көрсету',
  hide: 'Жасыру',
  mobileCalendarTexts: ['Күнді таңдаңыз', 'Аралықты таңдаңыз', 'Күндерді таңдаңыз'],
  range: ['бастап', 'дейін'],
  countTexts: ['Плюс', 'Минус'],
  time: {
    'HH:MM': 'HH:MM',
    'HH:MM AA': 'HH:MM AA',
    'HH:MM:SS': 'HH:MM:SS',
    'HH:MM:SS AA': 'HH:MM:SS AA',
    'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
    'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA'
  },
  dateTexts: {
    DMY: 'dd.mm.yyyy',
    MDY: 'mm.dd.yyyy',
    YMD: 'yyyy.mm.dd'
  },
  digitalInformationUnits: ['B', 'KiB', 'MiB'],
  passwordTexts: ['Құпия сөзді көрсету', 'Құпия сөзді жасыру'],
  copyTexts: ['Көшіру', 'Көшірілген'],
  shortCalendarMonths: ['Қаң', 'Ақп', 'Нау', 'Сәу', 'Мам', 'Мау', 'Шіл', 'Там', 'Қыр', 'Қаз', 'Қар', 'Жел'],
  pagination: ['Алдыңғы бет', 'Келесі бет'],
  fileTexts: {
    loadingError: 'Жүктеп салу сәтсіз аяқталды',
    preview: 'Алдын ала қарау',
    remove: 'Жою'
  },
  inputFileTexts: {
    defaultLabelSingle: 'немесе тастаңыз\u00A0ол\u00A0мұнда',
    defaultLabelMultiple: 'немесе тастаңыз\u00A0олар\u00A0мұнда',
    defaultLinkSingle: 'Файлды таңдаңыз',
    defaultLinkMultiple: 'Файлдарды таңдаңыз',
    maxSizeRejectionReason: 'Файл тым үлкен',
    formatRejectionReason: 'Қате файл түрі',
    drop: 'Файлды осы жерге тастаңыз',
    dropMultiple: 'Файлдарды осы жерге тастаңыз'
  },
  multiSelectTexts: {
    all: 'Барлығын таңдаңыз',
    none: 'Ешбіреуін таңдау'
  },
  confirm: {
    yes: 'Иә',
    no: 'Жоқ'
  },
  previewTexts: {
    rotate: 'Айналдыру'
  },
  zoomTexts: {
    zoomOut: 'Кішірейту',
    zoomIn: 'Үлкейту',
    reset: 'Қалпына келтіру'
  },
  phoneSearch: 'Елді немесе кодты теріңіз'
};
const TUI_KAZAKH_LANGUAGE_LAYOUT = {
  inputSearch: {
    popular: 'Popular',
    history: 'Recent',
    placeholder: 'Type query',
    hotkey: 'to search',
    all: 'All',
    empty: 'Nothing found'
  }
};
const TUI_KAZAKH_LANGUAGE = {
  name: 'kazakh',
  ...TUI_KAZAKH_LANGUAGE_CORE,
  ...TUI_KAZAKH_LANGUAGE_KIT,
  ...TUI_KAZAKH_LANGUAGE_ADDON_TABLE,
  ...TUI_KAZAKH_LANGUAGE_ADDON_COMMERCE,
  ...TUI_KAZAKH_LANGUAGE_ADDON_EDITOR,
  ...TUI_KAZAKH_LANGUAGE_LAYOUT
};

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_KAZAKH_LANGUAGE, TUI_KAZAKH_LANGUAGE_ADDON_COMMERCE, TUI_KAZAKH_LANGUAGE_ADDON_EDITOR, TUI_KAZAKH_LANGUAGE_ADDON_TABLE, TUI_KAZAKH_LANGUAGE_CORE, TUI_KAZAKH_LANGUAGE_COUNTRIES, TUI_KAZAKH_LANGUAGE_KIT, TUI_KAZAKH_LANGUAGE_LAYOUT };
